import React, { useState, useEffect } from "react";

import { fetchAuthenticated } from 'services/fetch';
import { emitEvent } from 'utils/events';

import LockForm from 'components/forms/LockForm';

export default function EditLock(props) {
  const { match, history, setBreadcrumbs } = props;
  const [lock, setLock] = useState({});

  const lockURL = `lock/${match.params.id}`;

  useEffect(() => {
    setBreadcrumbs([
      { path: '/cadastros/cadeados', label: 'Cadeados' },
      { path: '', label: `${(lock && lock.name) || ''}` },
    ]);
    return () => { setBreadcrumbs([]); };
  }, [setBreadcrumbs, match.params.id, lock]);

  useEffect(() => {
    const fn = async () => {
      emitEvent('showGlobalLinearProgress');
      const response = await fetchAuthenticated('get', lockURL);

      if (response.status >= 400) {
        emitEvent('showSnack', { message: 'Não foi possível carregar o cadeado', type: 'error' });
        history.push('/cadastros/cadeados');
      } else {
        const data = await response.json();
        setLock(data);
        emitEvent('hideGlobalLinearProgress');
      }
    };
    fn();
  }, [history, lockURL]);

  const handleSubmit = async (data) => {
    const response = await fetchAuthenticated('put', lockURL, data);

    if (!response.ok) {
      throw new Error('');
    } else {
      const data = await response.json();
      setLock(data);
      emitEvent('showSnack', { message: 'Cadeado atualizado com sucesso', type: 'success' });
    }
  };

  const handleCancel = () => {
    history.push('/cadastros/cadeados');
  };

  return (
    <div>
      <LockForm
        title="Detalhes do Cadeado"
        data={lock}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
      />
    </div>
  );
}
